import React, { useEffect, useState } from "react";
import { BaseUrl, newBaseUrlLang } from "../../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import {
  setExternalChatData,
  UpdateExternalContactList,
} from "../../../../Redux/Actions/actions";
import FormControl from "@mui/material/FormControl";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
} from "@mui/material";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { toaststyle } from "../../../../Utils/toaststyle";

const mapStateToProps = (state) => {
  return {
    externalChatData: state.contactListData.externalChatData,
  };
};

const TransferSkillset = (props) => {
  const { OpenDialog, handleClose } = props;
  const [skilldropdown, setSkilldropdown] = useState([]);
  const [selectskillsetformail, setSelectSkillsetforMail] = useState("");
  const [skillSetValidation, setskillSetValidation] = useState(false);

  const skillsetDropdown = () => {
    let data = {
      enabled: true,
    };
    axios
      .post(newBaseUrlLang + "usermodule/clientMaster/skills/list", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        setSkilldropdown(res.data.dataList);
      })
      .catch((error) => {});
  };

  const transferEmailtoAgent = () => {
    if (!selectskillsetformail) {
      setskillSetValidation(true);
      return;
    }

    let data = {
      sessionId: props.externalChatData
        ? props.externalChatData.chat_session_id
        : "",
      skillset: selectskillsetformail,
    };
    axios
      .post(BaseUrl + "/email/transferEmail", data, {
        headers: {
          tenantId: localStorage.getItem("TenantId"),
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        if (res.data.status) {
          props.setExternalChatData("");
          props.UpdateExternalContactList(
            JSON.parse(localStorage.getItem("client")).chat_session_id
          );
          toast.success(res.data.message, toaststyle);
        } else {
          props.setExternalChatData("");
          props.UpdateExternalContactList(
            JSON.parse(localStorage.getItem("client")).chat_session_id
          );
          toast.error(res.data.message, toaststyle);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    skillsetDropdown();
  }, []);

  return (
    <Dialog
      open={OpenDialog}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
        }}
      >
        Transfer Skillset
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Stack
            className="mt-3"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <label
              for="exampleFormControlTextarea1"
              className="form-label fs-13"
            >
              Skillset
            </label>
            <select
              className={`form-select form-select-sm ${
                skillSetValidation ? "is-invalid" : ""
              }`}
              aria-label="Default select example"
              onChange={(e) => {
                setSelectSkillsetforMail(e.target.value);
                if (e.target.value) {
                  setskillSetValidation(false);
                }
              }}
            >
              <option selected disabled value="">
                Choose Skillset
              </option>
              {skilldropdown.map((item, index) => {
                return (
                  <option value={item.skillName} key={index}>
                    {item.skillName}
                  </option>
                );
              })}
            </select>

            {skillSetValidation && (
              <div className="invalid-feedback">Please select a Skillset</div>
            )}
          </Stack>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>

        <Button
          onClick={() => {
            transferEmailtoAgent();
          }}
          vautoFocus
          sx={{ textTransform: "capitalize !important" }}
          variant="contained"
          size="small"
          disableElevation
        >
          Transfer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {
  setExternalChatData,
  UpdateExternalContactList,
})(TransferSkillset);
